import barcodeCreatorTemplate from '../templates/barcode-creator-template.html?raw';
import barcodeDecoderTemplate from '../templates/barcode-decoder-template.html?raw';
import qrCreatorTemplate from '../templates/qr-creator-template.html?raw';
import qrDecoderTemplate from '../templates/qr-decoder-template.html?raw';
import loginTemplate from '../templates/login-template.html?raw';
import feedbackTemplate from '../templates/feedback-template.html?raw';
import privacyTemplate from '../templates/privacy-template.html?raw';
import shortcutsTemplate from '../templates/shortcuts-template.html?raw';
import subscriptionTemplate from '../templates/subscription-template.html?raw';
import aboutTemplate from '../templates/about-template.html?raw';
import notificationTemplate from '../templates/notification-template.html?raw';
import settingsTemplate from '../templates/settings-template.html?raw';
import whyUpgradeTemplate from '../templates/why-upgrade-template.html?raw';
import analyticsTemplate from '../templates/analytics-template.html?raw';
import invoiceTemplate from '../templates/invoice-template.html?raw';
import guideTemplate from '../templates/guide-template.html?raw';
import dynamicTemplate from '../templates/dynamic-template.html?raw';

export const templates = {
    'barcode-creator-template': barcodeCreatorTemplate,
    'barcode-decoder-template': barcodeDecoderTemplate,
    'qr-creator-template': qrCreatorTemplate,
    'qr-decoder-template': qrDecoderTemplate,
    'login-template': loginTemplate,
    'feedback-template': feedbackTemplate,
    'privacy-template': privacyTemplate,
    'shortcuts-template': shortcutsTemplate,
    'subscription-template': subscriptionTemplate,
    'about-template': aboutTemplate,
    'notification-template': notificationTemplate,
    'settings-template': settingsTemplate,
    'why-upgrade-template': whyUpgradeTemplate,
    'analytics-template': analyticsTemplate,
    'invoice-template': invoiceTemplate,
    'guide-template': guideTemplate,
    'dynamic-template': dynamicTemplate,
};
